module.exports = __webpack_public_path__ + "static/media/arrow-down.560e7706.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-down.svg
// module id = 144
// module chunks = 0